var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.$t("table.widgetsCenter"),
        width: "900px",
        footer: null,
      },
      on: { cancel: _vm.closeModal },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "widgets-center" }, [
        _c("div", { staticClass: "categories" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("chatbotv2.categories")))]),
          _vm._v(" "),
          _c("ul", { staticClass: "category-list" }, [
            _c("li", { staticClass: "category-item active" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("tables.suggested"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("table.stayUpdated"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("table.motivation"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("table.media"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("table.personal"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("table.supsisApps"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("table.marketplaceApps"))),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "widgets-container" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("tables.suggested")))]),
          _vm._v(" "),
          _c("div", { staticClass: "widgets-grid" }, [
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/chart.png",
                      alt: _vm.$t("tables.graph"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("tables.graph"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.graphDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("chart")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/numbers.png",
                      alt: _vm.$t("tables.numbers"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("tables.numbers"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.numbersDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("numbers")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/text.png",
                      alt: _vm.$t("message.text"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.text"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.textDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("text")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/countdown.png",
                      alt: _vm.$t("table.countdownWidget"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("tables.countdown"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.countdownDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("countdown")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/iframe.png",
                      alt: _vm.$t("table.iframeWidget"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("table.iframeWidget"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.iframeDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("iframe")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/youtube.png",
                      alt: _vm.$t("table.youtubeWidget"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("table.youtubeWidget"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.youtubeDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("youtube")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/gantt.png",
                      alt: _vm.$t("table.ganttWidget"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("table.ganttWidget"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("table.visualizeTasksOnTimeline"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("gantt")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/pivot.svg",
                      alt: _vm.$t("table.pivotWidget"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("table.pivotWidget"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("table.analyzePivotTable"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("pivot")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }